// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom'; // Updated imports
import HeaderFusionTales  from './countryQuest/components/HeaderFusionTales';
import PrivacyPolicyFusionTales  from './countryQuest/components/PrivacyPolicyFusionTales';
import StoreLinksFusionTales  from './countryQuest/components/StoreLinksFusionTales';
import './App.css';
import './countryQuest/styles/countryQuest.css'; // Import specific styles

function App() {
  return (
    <Router>
      <div className="App">
        <main>
          {/* Replaced Switch with Routes */}
          <Routes>
            {/* Route now uses the element prop */}
            <Route path="/privacy-policy/:appName" element={<AppContent />} />
            <Route path="/*" element={<AppContent />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

// A component that dynamically loads the correct header and privacy policy based on the appName
function AppContent() {
  const { appName } = useParams(); // Get appName from the URL

  // Dynamically choose the header based on appName
  const renderAllContent = () => {
    return (
      <div className="App">
        <HeaderFusionTales  />
        <main>
          <PrivacyPolicyFusionTales  />
          <StoreLinksFusionTales  />
        </main>
      </div>
    );
  };

  return (
    <>
      {renderAllContent()}
    </>
  );
}

export default App;
